import styled from "styled-components";

const Styles = styled.div``;

export default Styles;
